// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kn-0";
export var assigneeDetails = "_kn-1";
export var assigneeInfo = "_kn-2";
export var dropdownContainer = "_kn-4";
export var dropdownImage = "_kn-5";
export var editAssigneeInfo = "_kn-3";
export var editAssigneeModalContainer = "_kn-6";
export var hidden = "_kn-8";
export var input = "_kn-7";